module.exports = __webpack_public_path__ + "static/media/lincoln-pin.7999277f.svg";